import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import theme from "../theme/theme";
import Gallery from "./Gallery";
import { Helmet } from "react-helmet-async";

const vicePresidents = [
  {
    name: "Mr. Rajender Golan",
    designation: "Vice President ",
    quote:
      "Our innovative biometric solutions enhance security by providing personalized protection, ensuring safety and trust in every aspect of your life, empowering you to feel secure with cutting-edge technology.",
    image: require("../assets/rajender_sir.png"), // Adjust the path accordingly
  },
  {
    name: "Mr. Shashi Bhushan Mishra",
    designation: "Vice President",
    quote:
      "Our mission is to revolutionize how people perceive and manage their time. Through innovation and customer-centric strategies, we aim to build lasting relationships and lead the market with creativity.",
    image: require("../assets/shashi_sir.jpg"),
  },
];

{
  /*const heads = [
  {
    name: "Mr. Bhaskar Mani",
    designation: "Chief Technology Officer",
    quote:
      "Innovation means delivering smart, secure solutions that empower users to master their time effortlessly.",
    image: require("../assets/images/dummy.jpg"), // Adjust the path accordingly
  },
  {
    name: "Mr. Nitin Mishra",
    designation: "Deputy General Manager",
    quote:
      "We pursue excellence in every detail, ensuring our solutions make time management impactful.",
    image: require("../assets/images/dummy.jpg"),
  },
  {
    name: "Mr. Suraj Rai",
    designation: "Accounts & Finance Manager",
    quote:
      "Efficiency and precision are central to our strategy, optimizing every second and resource for growth.",
    image: require("../assets/images/dummy.jpg"),
  },
];*/
}

const AboutDetail = () => {
  return (
    <>
      

      <div className="container my-5">
        {/* First Section - Our Story */}
        <div className="row align-items-center">
          <div className="col-md-6">
            <h2>Our Story: Building a Better Future</h2>
            <p>
              At{" "}
              <span className="fw-bold">
                <span style={{ color: "#d53539" }}>Time</span>
                <span style={{ color: "#6e7072" }}>Watch</span>
              </span>
              , we are dedicated to innovating, manufacturing, and automating
              products across a broad range of security solutions, including{" "}
              <span className="fw-bold">
                Time & Attendance, Access Control, Entrance Control, Traffic &
                Parking Control, Inspection Systems, Software & Application
                Solutions.
              </span>{" "}
            </p>
            <p className="mt-3">
              We integrate <span className="fw-bold">AI</span> and{" "}
              <span className="fw-bold">Machine Learning </span> to provide
              cutting-edge products. Our comprehensive software suite includes:
              <ul>
                <li>Time & Attendance Management</li>
                <li>Parking & Traffic Management</li>
                <li>Payroll Management</li>
                <li>Visitor Management</li>
                <li>Canteen & Gym Management</li>
              </ul>
            </p>
            <p className="mt-3">
              We are a<span className="fw-bold"> Process, Technology, </span>
              and <span className="fw-bold">System-Driven </span>company,
              committed to
              <span className="fw-bold">
                {" "}
                Innovation, Customer Delight,{" "}
              </span>{" "}
              and continuous support.
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img
              src="https://timewatch.co.in/images/building.png"
              alt="management"
              className="img-fluid"
            />
          </div>
        </div>

        {/* Second Section - Vision, Mission, Core Values */}
        <div className="row align-items-center mt-5">
          <div className="col-md-6">
            <img
              src="https://timewatch.co.in/images/vision.jpg"
              alt="vision"
              className="img-fluid"
            />
          </div>
          <div className="col-md-6">
            <ul className="list-unstyled">
              <li className="mb-4">
                <img
                  src="https://timewatch.co.in/images/vision-logo.png"
                  alt="bullet"
                  className="me-2"
                  width="30"
                />
                <span className="fw-bold">Vision:</span> <br />
                To become one of the top five global leaders in Time &
                Attendance, Access Control, Entrance Control, Traffic & Parking
                Control and Inspection Control Systems, renowned for our quality
                products and exceptional customer support that delights our
                clients.
              </li>
              <li className="mb-4">
                <img
                  src="https://timewatch.co.in/images/mission.png"
                  alt="bullet"
                  className="me-2"
                  width="30"
                />
                <span className="fw-bold">Mission:</span> <br />
                To innovate and develop smart Time & Attendance, Access Control,
                Entrance Control, Traffic & Parking Control, Inspection Control
                products under one roof, helping our clients secure their
                premises effectively.
              </li>
              <li className="mb-4">
                <img
                  src="https://timewatch.co.in/images/core-value.png"
                  alt="bullet"
                  className="me-2"
                  width="30"
                />
                <span className="fw-bold">Core Values:</span> <br />
                IIBSS - Identify | Innovate | Build | Supply | Support
              </li>
            </ul>
          </div>
        </div>

        {/*Third Section - VPs */}
        <div className="mt-5">
          <h2 className="text-center" style={{ textAlign: "left" }}>
            Executive Leadership: Meet Our VPs
          </h2>
          <div className="row mt-4">
            {vicePresidents.map((vp, index) => (
              <div key={index} className="col-md-6 mb-4">
                <div
                  className="card"
                  style={{
                    backgroundColor: "transparent",
                    width: theme.card.width,
                    transform: "none",
                  }}
                  onMouseEnter={(e) => (
                    (e.currentTarget.style.transform = "scale(1)"),
                    (e.currentTarget.style.boxShadow = "none")
                  )}
                  onMouseLeave={(e) => (
                    (e.currentTarget.style.transform = "scale(1)"),
                    (e.currentTarget.style.boxShadow = "none")
                  )}
                >
                  <img
                    src={vp.image}
                    className="card-img-top"
                    alt={vp.name}
                    style={{
                      height: "300px",
                      width: "300px",
                      objectFit: "cover",
                    }} // Ensures the image is fully visible
                  />
                  <div
                    className="card-body"
                    style={{
                      backgroundColor: "transparent",
                      textAlign: "center",
                      marginTop: "10px",
                    }}
                  >
                    <h5
                      className="card-title"
                      style={{
                        color: theme.colors.vpNameColor,
                        fontWeight: theme.text.vpName.fontWeight,
                        fontSize: theme.text.vpName.fontSize,
                      }}
                    >
                      {vp.name}
                    </h5>
                    <h6
                      className="card-subtitle mb-2"
                      style={{
                        color: theme.colors.vpDesignationColor,
                        fontWeight: theme.text.vpDesignation.fontWeight,
                        fontSize: theme.text.vpDesignation.fontSize,
                      }}
                    >
                      {vp.designation}
                    </h6>
                    <p
                      className="card-text"
                      style={{
                        color: theme.colors.vpQuoteColor,
                        fontWeight: theme.text.vpQuote.fontWeight,
                        fontSize: theme.text.vpQuote.fontSize,
                      }}
                    >
                      {vp.quote}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/*Fourth Section - HODs */}
        {/*<div className="mt-5">
        <h2 className="text-left">Head of Departments</h2>
        <div className="row mt-4">
          {heads.map((hod, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div
                className="card"
                style={{
                  backgroundColor: theme.colors.cardBackground,
                  borderRadius: theme.card.borderRadius,
                  boxShadow: theme.card.dropShadow,
                  width: theme.card.width,
                }}
              >
                <img
                  src={hod.image}
                  className="card-img-top"
                  alt={hod.name}
                  style={{ height: "auto", objectFit: "cover" }} // Ensures the image is fully visible
                />
                <div
                  className="card-body"
                  style={{
                    backgroundColor: theme.colors.cardBodyBackground,
                    borderRadius: theme.card.bodyBorderRadius,
                    boxShadow: theme.card.dropShadow,
                    textAlign: "left",
                    marginTop: '10px'
                  }}
                >
                  <h5
                    className="card-title"
                    style={{
                      color: theme.colors.vpNameColor,
                      fontWeight: theme.text.vpName.fontWeight,
                      fontSize: theme.text.vpName.fontSize,
                    }}
                  >
                    {hod.name}
                  </h5>
                  <h6
                    className="card-subtitle mb-2"
                    style={{
                      color: theme.colors.vpDesignationColor,
                      fontWeight: theme.text.vpDesignation.fontWeight,
                      fontSize: theme.text.vpDesignation.fontSize,
                    }}
                  >
                    {hod.designation}
                  </h6>
                  <p
                    className="card-text"
                    style={{
                      color: theme.colors.vpQuoteColor,
                      fontWeight: theme.text.vpQuote.fontWeight,
                      fontSize: theme.text.vpQuote.fontSize,
                    }}
                  >
                    "{hod.quote}"
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>*/}

        {/* Testimonials Section */}
        <div className="mt-5"></div>
        <Gallery />
      </div>
    </>
  );
};

export default AboutDetail;
